export function animateCounts() {
    if ($('.countUp').length > 0) {
        checkCountLine();
        $(window).scroll(function () {
            checkCountLine();
        });
        $(window).resize(function () {
            checkCountLine();
        });
    }
}
